// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"1a3e699c","678":"6031e431"}[chunkId] + ".chunk.js";
};